export function clog(...args) {
    console
        .log.apply(console, arguments);
}
